import { render, staticRenderFns } from "./binInspection.vue?vue&type=template&id=536377f4&scoped=true"
import script from "./binInspection.vue?vue&type=script&lang=js"
export * from "./binInspection.vue?vue&type=script&lang=js"
import style0 from "./binInspection.vue?vue&type=style&index=0&id=536377f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536377f4",
  null
  
)

export default component.exports